"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

require("../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/*eslint-disable valid-jsdoc*/

/**
* @module util/KeyboardUtils
* @desc A set of keyboard util functions.
*/

/**
 * @enum {number}
 * @alias module:util/KeyboardUtils.KeyCodes
 * @desc An enum of keyboard key codes.
 */
exports.KeyCodes = {
  TAB: 9,
  ESC: 27,
  ENTER: 13,
  LEFT_SHIFT: 16,
  LEFT_CTRL: 17,
  LEFT_ALT: 18,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  LEFT_CMD: 91,
  RIGHT_CMD: 92,
  RIGHT_ALT: 93,
  SPACE: 32,
  BACK_SPACE: 8,
  DELETE: 46,
  COMMA: 188
};
/**
 * @alias module:util/KeyboardUtils.ModifierCodes
 * @desc An array of keyboard modifier key codes.
 */

exports.ModifierCodes = [exports.KeyCodes.LEFT_SHIFT, exports.KeyCodes.LEFT_CTRL, exports.KeyCodes.LEFT_ALT, exports.KeyCodes.LEFT_CMD, exports.KeyCodes.RIGHT_CMD, exports.KeyCodes.RIGHT_ALT];

var compare = function compare(code, expected) {
  return code === expected;
}; //generate checker functions for each item in the KeyCodes map in the form of is<Key>(code)


for (var k in exports.KeyCodes) {
  var name = k.substr(0, 1) + k.substr(1).toLowerCase().replace(/_./g, function (match) {
    return match.substr(1).toUpperCase();
  }); //see below for JSDocs for all these functions

  exports["is" + name] = (0, _bind.default)(compare).call(compare, null, exports.KeyCodes[k]);
}
/**
* @alias module:util/KeyboardUtils.isModifier
* @desc Checks whether code is a keyboard modifier key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard modifier key code.
*/


exports.isModifier = function (code) {
  var _context;

  return (0, _indexOf.default)(_context = exports.ModifierCodes).call(_context, code) !== -1;
};
/**
* @alias module:util/KeyboardUtils.isArrowKey
* @desc Checks whether code is a keyboard arrow (up/down/left/right) key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard arrow (up/down/left/right) key code.
*/


exports.isArrowKey = function (code) {
  return exports.isArrowUp(code) || exports.isArrowDown(code) || exports.isArrowLeft(code) || exports.isArrowRight(code);
};
/**
* @alias module:util/KeyboardUtils.isNavigationKey
* @desc Checks whether code is a navigation key (up/down/left/right/home/end) key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a navigation key (up/down/left/right/home/end) key code.
*/


exports.isNavigationKey = function (code) {
  return exports.isArrowKey(code) || exports.isHome(code) || exports.isEnd(code);
};
/**
* @function module:util/KeyboardUtils.isTag
* @desc Checks whether code is a keyboard modifier tag key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard tag key code.
*/

/**
* @function module:util/KeyboardUtils.isEsc
* @desc Checks whether code is a keyboard modifier esc key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard esc key code.
*/

/**
* @function module:util/KeyboardUtils.isEnter
* @desc Checks whether code is a keyboard modifier enter key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard enter key code.
*/

/**
* @function module:util/KeyboardUtils.isLeftShift
* @desc Checks whether code is a keyboard modifier left shift key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard left shift key code.
*/

/**
* @function module:util/KeyboardUtils.isLeftCtrl
* @desc Checks whether code is a keyboard modifier left ctrl key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard left ctrl key code.
*/

/**
* @function module:util/KeyboardUtils.isLeftAlt
* @desc Checks whether code is a keyboard modifier left alt key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard left alt key code.
*/

/**
* @function module:util/KeyboardUtils.isArrowLeft
* @desc Checks whether code is a keyboard modifier left arrow key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard left arrow key code.
*/

/**
* @function module:util/KeyboardUtils.isArrowUp
* @desc Checks whether code is a keyboard modifier up arrow key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard up arrow key code.
*/

/**
* @function module:util/KeyboardUtils.isArrowRight
* @desc Checks whether code is a keyboard modifier right arrow key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard right arrow key code.
*/

/**
* @function module:util/KeyboardUtils.isArrowDown
* @desc Checks whether code is a keyboard modifier down arrow key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard down arrow key code.
*/

/**
* @function module:util/KeyboardUtils.isLeftCmd
* @desc Checks whether code is a keyboard modifier left cmd key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard left cmd key code.
*/

/**
* @function module:util/KeyboardUtils.isRightCmd
* @desc Checks whether code is a keyboard modifier right cmd key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard right cmd key code.
*/

/**
* @function module:util/KeyboardUtils.isRightAlt
* @desc Checks whether code is a keyboard modifier right alt key code.
*
* @param {number} code
*    The code to check.
*
* @return {boolean}
*    Whether or not the code is a keyboard right alt key code.
*/
// Trying to get global event listeners to actually fire in Jest is really, really complicated.

/* istanbul ignore next  */


var addFocusClass = function addFocusClass(_ref) {
  var keyCode = _ref.keyCode;

  if (keyCode === 9) {
    document.body.classList.add("ui-library-focus-visible");
  }
};
/* istanbul ignore next  */


var removeFocusClass = function removeFocusClass() {
  return document.body.classList.remove("ui-library-focus-visible");
};

var addCountAndListeners = function addCountAndListeners() {
  var componentCount = (0, _parseInt2.default)(document.body.dataset.uiLibComponentCount || 0, 10);

  if (componentCount > 0) {
    document.body.dataset.uiLibComponentCount = componentCount + 1;
  } else {
    document.body.dataset.uiLibComponentCount = 1;
    document.addEventListener("keydown", addFocusClass);
    document.addEventListener("mousedown", removeFocusClass);
  }
};

var removeCountAndListeners = function removeCountAndListeners() {
  var componentCount = (0, _parseInt2.default)(document.body.dataset.uiLibComponentCount || 0, 10);

  if (componentCount === 1) {
    document.body.dataset.uiLibComponentCount = 0;
    document.removeEventListener("keydown", addFocusClass);
    document.removeEventListener("mousedown", removeFocusClass);
    removeFocusClass();
  } else {
    document.body.dataset.uiLibComponentCount = componentCount - 1;
  }
};

var useFocusOutline = function useFocusOutline() {
  (0, _react.useEffect)(function () {
    addCountAndListeners();
    return function () {
      removeCountAndListeners();
    };
  });
};

exports.useFocusOutline = useFocusOutline;
/**
* @function module:util/KeyboardUtils.withFocusOutline
* @desc
*    A higher order component that sets up a component to show focus outlines when tab
*       is pressed and removes them when the mouse is used.
*
* @return {function}
*    The component, but now with lifecycle methods to add global listeners for adding and
*    removing focus class.
*/

exports.withFocusOutline = function (WrappedComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(_class, _Component);

    var _super = _createSuper(_class);

    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        addCountAndListeners();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        removeCountAndListeners();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
      }
    }]);
    return _class;
  }(_react.Component), (0, _defineProperty2.default)(_class, "displayName", WrappedComponent.displayName || WrappedComponent.name), _temp;
};